<template>
  <div class="detail-header mb-4">
    <v-row>
      <v-col cols="12" md="6">
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.id') }}:</div>
          <div class="detail-value">{{ item.id }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.definition') }}:</div>
          <div class="detail-value">{{ item.definition }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.type') }}:</div>
          <div class="detail-value">
            <v-chip
              small
              :color="item.type === 'workflow' ? 'blue' : 'green'"
              text-color="white"
            >
              {{ item.type }}
            </v-chip>
          </div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.transports') }}:</div>
          <div class="detail-value">
            <template v-if="Array.isArray(item.transports) && item.transports.length">
              <v-chip
                v-for="(t, idx) in item.transports"
                :key="`transport-${idx}-${t}`"
                small
                color="blue lighten-2"
                text-color="white"
                class="mr-1"
              >
                {{ t }}
              </v-chip>
            </template>
            <template v-else>
              <span>-</span>
            </template>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.user') }}:</div>
          <div class="detail-value">{{ item.user }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.created-at') }}:</div>
          <div class="detail-value">{{ formatDate(item.created_at) }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.started-at') }}:</div>
          <div class="detail-value">{{ item.execution_started_at ? formatDate(item.execution_started_at) : '-' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.finished-at') }}:</div>
          <div class="detail-value">{{ item.execution_finished_at ? formatDate(item.execution_finished_at) : '-' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t('job-manager.duration') }}:</div>
          <div class="detail-value">{{ item.duration }}</div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DetailHeader',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    getStatusColor(status) {
      const colors = {
        pending: 'orange',
        running: 'blue',
        success: 'green',
        failed: 'red',
        cancelled: 'grey',
        awaiting_approval: 'purple'
      };
      return colors[status] || 'grey';
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-item {
  display: flex;
  margin-bottom: 10px;

  .detail-label {
    font-weight: bold;
    min-width: 120px;
  }

  .detail-value {
    flex: 1;
  }
}
</style>